export const onSite = {
  OnSiteProducts: "On-site products",
  SendingProductsHome:
    "Sending products home with {{patientTermPlural}}? Mark which are sent virtually, and which are on-site to drive smarter refill reminders and better {{patientTerm}} adherence.",
  CustomizeTool: "Customize tool",
  TurnFeaturesOnAndOff:
    "Turn features you use on and off. This affects only your personal account, and not the entire dispensary.",
  TurnOnSiteOff: "Turn On-site products feature off",
  TurnOnSiteOn: "Turn On-site products feature on",
  PrescribeYourOnsiteProducts: "{{treatmentPlanTerm}} your on-site products with ease!",
  FlagProductsSoldInOffice: "Flag products sold in-office, unlock smart refill reminders.",
  FollowUpWithPatients:
    "Follow up with {{patientTermPlural}} who might need help getting started. Surveys are sent if a {{patientTerm}} doesn't fill their {{treatmentPlanTerm}} after 7 days.",
  TheAdherenceSurvey:
    "The Adherence Survey asks questions based on common compliance barriers experienced by {{patientTermPlural}} so that you can receive feedback quickly and easily.",
  TheseSettingsApplyToYourAccountOnly:
    "These settings apply to your account only – not the entire dispensary.",
  ManageSettings: "Manage settings",
} as const;
